var map = {
	"./avatar-1.jpg": "./src/assets/images/user/avatar-1.jpg",
	"./avatar-2.jpg": "./src/assets/images/user/avatar-2.jpg",
	"./avatar-3.jpg": "./src/assets/images/user/avatar-3.jpg",
	"./avatar-4.jpg": "./src/assets/images/user/avatar-4.jpg",
	"./avatar-5.jpg": "./src/assets/images/user/avatar-5.jpg",
	"./cover.jpg": "./src/assets/images/user/cover.jpg",
	"./doctor-male-64.png": "./src/assets/images/user/doctor-male-64.png",
	"./img-avatar-1.jpg": "./src/assets/images/user/img-avatar-1.jpg",
	"./img-avatar-2.jpg": "./src/assets/images/user/img-avatar-2.jpg",
	"./img-avatar-3.jpg": "./src/assets/images/user/img-avatar-3.jpg",
	"./lock.png": "./src/assets/images/user/lock.png",
	"./nurse-female-64.png": "./src/assets/images/user/nurse-female-64.png",
	"./patient-female-128.png": "./src/assets/images/user/patient-female-128.png",
	"./patient-female-oldage-128.png": "./src/assets/images/user/patient-female-oldage-128.png",
	"./patient-male-128.png": "./src/assets/images/user/patient-male-128.png",
	"./patient-male-oldage-128.png": "./src/assets/images/user/patient-male-oldage-128.png",
	"./pharmacist-male-64.png": "./src/assets/images/user/pharmacist-male-64.png",
	"./sex-male-female-128.png": "./src/assets/images/user/sex-male-female-128.png",
	"./user-1.png": "./src/assets/images/user/user-1.png",
	"./user-2.png": "./src/assets/images/user/user-2.png",
	"./user-3-256.png": "./src/assets/images/user/user-3-256.png",
	"./user.png": "./src/assets/images/user/user.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/user sync recursive ^\\.\\/.*$";